import InternalTicketsRepositoryInterface, { Ticket } from '@/services/Internal-Tickets/interfaces';

export default class Utils {


  public static async transformUserIdsToNames(
    bugs: Ticket[],
    internalTicketsRepository: InternalTicketsRepositoryInterface,
  ): Promise<Ticket[]> {
    const ids = bugs.reduce((ids: string[], obj) => {
      if (obj.reporter && !ids.includes(obj.reporter)) {
        ids.push(obj.reporter);
      }
      if (obj.assignee && !ids.includes(obj.assignee.userId)) {
        ids.push(obj.assignee.userId);
      }
      return ids;
    }, []);

    const data: any[] = await internalTicketsRepository.getUsersData(ids);
    console.log('here is the data');

    bugs = bugs.map(bug => {
      const matchingReporter = data.find(user => user.userId === bug.reporter);

      if (matchingReporter) {
        bug.reporter = `${matchingReporter.firstName} ${matchingReporter.lastName}`;
      }

      if (bug.assignee) {
        const matchingAssignee = data.find(user => user.userId === bug.assignee.userId);
        if (matchingAssignee) {
          bug.assignee.userId = `${matchingReporter.firstName} ${matchingReporter.lastName}`;
        }
      }

      // if (!bug.assignee) {
      //   bug.assignee = 'not assigned';
      // }

      return bug;
    });
    return bugs;
  }
}
